module.exports = __webpack_public_path__ + "img/loading.0e37d04f.gif";